import { Box } from '@mui/system'
import React from 'react'
import './Dashboardhome.css'
function Dashboardhome() {
    return (
         <Box className="dashboardhome-wrapper">
             <title>Dashboard home</title>
            
        </Box>
    )
}

export default Dashboardhome